import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Buffer from '../webgl/buffer';
import { glKey } from '../webgl-utils/constants-to-keys';
import { getCompositeGLType } from '../webgl-utils/attribute-utils';
import { formatValue } from '../utils'; // Creates object suitable as input for console.table

export function getDebugTableForVertexArray() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      vertexArray = _ref.vertexArray,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? 'Attributes' : _ref$header;

  if (!vertexArray.configuration) {
    return {};
  }

  var table = {}; // {[header]: {}};
  // Add index (elements) if available

  if (vertexArray.elements) {
    // const elements = Object.assign({size: 1}, vertexArray.elements);
    table.ELEMENT_ARRAY_BUFFER = getDebugTableRow(vertexArray, vertexArray.elements, null, header);
  } // Add used attributes


  var attributes = vertexArray.values;

  for (var attributeLocation in attributes) {
    var info = vertexArray._getAttributeInfo(attributeLocation);

    if (info) {
      var rowHeader = "".concat(attributeLocation, ": ").concat(info.name);
      var accessor = vertexArray.accessors[info.location];

      if (accessor) {
        rowHeader = "".concat(attributeLocation, ": ").concat(getGLSLDeclaration(info.name, accessor));
      }

      table[rowHeader] = getDebugTableRow(vertexArray, attributes[attributeLocation], accessor, header);
    }
  }

  return table;
}
/* eslint-disable max-statements */

function getDebugTableRow(vertexArray, attribute, accessor, header) {
  var _ref3;

  // const round = xnum => Math.round(num * 10) / 10;
  var gl = vertexArray.gl;
  var type = 'NOT PROVIDED';
  var size = 'N/A';
  var verts = 'N/A';
  var bytes = 'N/A';
  var isInteger;
  var marker;
  var value;

  if (accessor) {
    type = accessor.type;
    size = accessor.size; // Generate a type name by dropping Array from Float32Array etc.

    type = String(type).replace('Array', ''); // Look for 'nt' to detect integer types, e.g. Int32Array, Uint32Array

    isInteger = type.indexOf('nt') !== -1;
  }

  if (attribute instanceof Buffer) {
    var _ref2;

    var buffer = attribute;

    var _buffer$getDebugData = buffer.getDebugData(),
        data = _buffer$getDebugData.data,
        modified = _buffer$getDebugData.modified;

    marker = modified ? '*' : '';
    value = data;
    bytes = buffer.byteLength;
    verts = bytes / data.BYTES_PER_ELEMENT / size;
    var format;

    if (accessor) {
      var instanced = accessor.divisor > 0;
      format = "".concat(instanced ? 'I ' : 'P ', " ").concat(verts, " (x").concat(size, "=").concat(bytes, " bytes ").concat(glKey(gl, type), ")");
    } else {
      // element buffer
      isInteger = true;
      format = "".concat(bytes, " bytes");
    }

    return _ref2 = {}, _defineProperty(_ref2, header, "".concat(marker).concat(formatValue(value, {
      size: size,
      isInteger: isInteger
    }))), _defineProperty(_ref2, 'Format ', format), _ref2;
  } // CONSTANT VALUE


  value = attribute;
  size = attribute.length; // Generate a type name by dropping Array from Float32Array etc.

  type = String(attribute.constructor.name).replace('Array', ''); // Look for 'nt' to detect integer types, e.g. Int32Array, Uint32Array

  isInteger = type.indexOf('nt') !== -1;
  return _ref3 = {}, _defineProperty(_ref3, header, "".concat(formatValue(value, {
    size: size,
    isInteger: isInteger
  }), " (constant)")), _defineProperty(_ref3, 'Format ', "".concat(size, "x").concat(type, " (constant)")), _ref3;
}
/* eslint-ensable max-statements */


function getGLSLDeclaration(name, accessor) {
  var type = accessor.type,
      size = accessor.size;
  var typeAndName = getCompositeGLType(type, size);

  if (typeAndName) {
    return "".concat(name, " (").concat(typeAndName.name, ")");
  }

  return name;
}
//# sourceMappingURL=debug-vertex-array.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/webgl-debug/debug-vertex-array.js
// module id = 1602
// module chunks = 0